import { render, staticRenderFns } from "./BlogLocket.vue?vue&type=template&id=98c96706&"
import script from "./BlogLocket.vue?vue&type=script&lang=js&"
export * from "./BlogLocket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports